import type { Skill } from '../skillsData';

export const cryptoskillTradingCData: Skill[] = [
  {
    id: 'gas-optimizer-conditional',
    name: 'gas-optimizer-conditional',
    author: 'GasPro',
    authorHandle: '@gaspro',
    tag: 'Skill',
    category: 'trading',
    description: 'Conditional gas optimizer. Execute trades only when gas prices meet conditions, schedule transactions for optimal gas windows, and batch operations.',
    downloads: 9200,
    stars: 660,
    installCommand: '> install the gas-optimizer-conditional skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/gas-optimizer-conditional',
    usageExample: '> set gas condition\n> schedule optimal window\n> batch operations',
    detailedDescription: 'Smart conditional gas optimization for on-chain trading. Executes transactions only when gas prices fall below configured thresholds, schedules transactions for historically low gas windows, and batches multiple operations into single transactions for maximum cost efficiency.',
  },
  {
    id: 'gekko-portfolio-manager',
    name: 'gekko-portfolio-manager',
    author: 'Gekko',
    authorHandle: '@gekko_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'Gekko portfolio management. Multi-asset portfolio tracking, risk-adjusted rebalancing, and performance attribution across exchanges and wallets.',
    downloads: 8400,
    stars: 600,
    installCommand: '> install the gekko-portfolio-manager skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/gekko-portfolio-manager',
    usageExample: '> track multi-asset portfolio\n> rebalance risk-adjusted\n> attribute performance',
    detailedDescription: 'Gekko comprehensive portfolio management system. Tracks multi-asset portfolios across CEX, DEX, and self-custody wallets in real-time. Performs risk-adjusted rebalancing based on volatility and correlation, and provides detailed performance attribution by asset, strategy, and venue.',
  },
  {
    id: 'gekko-portfolio',
    name: 'gekko-portfolio',
    author: 'Gekko',
    authorHandle: '@gekko_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'Gekko portfolio tracker. Unified portfolio view across all venues, real-time PnL calculation, and historical performance visualization.',
    downloads: 11200,
    stars: 800,
    installCommand: '> install the gekko-portfolio skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/gekko-portfolio',
    usageExample: '> view unified portfolio\n> calculate real-time PnL\n> visualize performance',
    detailedDescription: 'Gekko unified portfolio tracking system. Aggregates positions, balances, and transaction history from all exchanges, DEXs, and wallets into a single dashboard. Calculates real-time PnL with cost basis tracking, and generates historical performance visualizations with drawdown and Sharpe ratio analysis.',
  },
  {
    id: 'gring-official-skills',
    name: 'gring-official-skills',
    author: 'Gring',
    authorHandle: '@gring_official',
    tag: 'Skill',
    category: 'trading',
    description: 'Gring official trading skills. Multi-chain execution, cross-protocol arbitrage, and institutional-grade order management through Gring infrastructure.',
    downloads: 7600,
    stars: 540,
    installCommand: '> install the gring-official-skills skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/gring-official-skills',
    usageExample: '> execute multi-chain\n> cross-protocol arb\n> manage institutional orders',
    detailedDescription: 'Gring official trading skills suite leveraging institutional-grade infrastructure. Executes trades across multiple chains simultaneously, identifies and executes cross-protocol arbitrage opportunities, and manages large block orders with minimal market impact through smart order routing.',
  },
  {
    id: 'gobo-api-feed',
    name: 'gobo-api-feed',
    author: 'Gobo',
    authorHandle: '@gobo_api',
    tag: 'Skill',
    category: 'trading',
    description: 'Gobo API data feed. Real-time market data aggregation, custom indicator feeds, and trading signal streaming via Gobo infrastructure.',
    downloads: 6200,
    stars: 440,
    installCommand: '> install the gobo-api-feed skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/gobo-api-feed',
    usageExample: '> aggregate market data\n> stream custom indicators\n> receive trading signals',
    detailedDescription: 'Gobo real-time data feed infrastructure for trading. Aggregates market data from 50+ exchanges and DEXs into unified streams, provides custom technical indicator feeds with configurable parameters, and streams AI-generated trading signals with confidence scores and historical backtest results.',
  },
  {
    id: 'grid-trading',
    name: 'grid-trading',
    author: 'GridBot',
    authorHandle: '@gridbot',
    tag: 'Skill',
    category: 'trading',
    description: 'Grid trading automation. Create, manage, and optimize grid trading bots with dynamic spacing, profit-taking, and risk controls.',
    downloads: 22400,
    stars: 1600,
    installCommand: '> install the grid-trading skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/grid-trading',
    usageExample: '> create grid bot\n> optimize spacing\n> manage grid positions',
    detailedDescription: 'Comprehensive grid trading automation platform. Create grid trading bots with customizable price ranges, number of grids, and investment amounts. Features dynamic grid spacing based on volatility, automatic profit-taking at grid levels, and integrated stop-loss and drawdown controls for risk management.',
  },
  {
    id: 'heytrum-pumper-prepper',
    name: 'heytrum-pumper-prepper',
    author: 'HeyTrum',
    authorHandle: '@heytrum',
    tag: 'Skill',
    category: 'trading',
    description: 'HeyTrum pumper prepper. Pre-position for anticipated pump events, monitor coordinated buying signals, and execute rapid exits.',
    downloads: 5800,
    stars: 410,
    installCommand: '> install the heytrum-pumper-prepper skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/heytrum-pumper-prepper',
    usageExample: '> pre-position for pump\n> monitor buying signals\n> execute rapid exit',
    detailedDescription: 'HeyTrum specialized pump event preparation system. Identifies tokens with high pump probability through coordinated wallet clustering analysis, pre-positions before anticipated events with optimal sizing, and executes rapid exits with automated profit-taking when momentum decays.',
  },
  {
    id: 'heyanon-pumpfun',
    name: 'heyanon-pumpfun',
    author: 'HeyAnon',
    authorHandle: '@heyanon_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'HeyAnon Pump.fun integration. Snipe new token launches, monitor bonding curves, and trade memecoins on Pump.fun with automated strategies.',
    downloads: 13200,
    stars: 940,
    installCommand: '> install the heyanon-pumpfun skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/heyanon-pumpfun',
    usageExample: '> snipe new launch\n> monitor bonding curve\n> auto-trade memecoin',
    detailedDescription: 'HeyAnon Pump.fun trading integration for Solana memecoins. Snipes new token launches within seconds of creation, monitors bonding curve progression for graduation probability estimation, and deploys automated trading strategies including sniping, scalping, and post-graduation Raydium migration trading.',
  },
  {
    id: 'hyperliquid-copy-trade',
    name: 'hyperliquid-copy-trade',
    author: 'Hyperliquid',
    authorHandle: '@hyperliquid_x',
    tag: 'Skill',
    category: 'trading',
    description: 'Hyperliquid copy trading. Mirror successful traders on Hyperliquid, manage copy ratios, and filter by performance metrics and risk profiles.',
    downloads: 11200,
    stars: 800,
    installCommand: '> install the hyperliquid-copy-trade skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/hyperliquid-copy-trade',
    usageExample: '> copy top trader\n> set copy ratio\n> filter by performance',
    detailedDescription: 'Hyperliquid copy trading integration. Mirrors trades from successful Hyperliquid vault managers and traders with configurable copy ratios. Filters signal providers by historical performance metrics including Sharpe ratio, drawdown, and win rate. Manages copy positions with automatic scaling and stop-loss controls.',
  },
  {
    id: 'hyperliquid-heyanon',
    name: 'hyperliquid-heyanon',
    author: 'Hyperliquid',
    authorHandle: '@hyperliquid_x',
    tag: 'Skill',
    category: 'trading',
    description: 'Hyperliquid HeyAnon integration. Natural language trading on Hyperliquid via HeyAnon AI assistant with conversational order placement.',
    downloads: 8400,
    stars: 600,
    installCommand: '> install the hyperliquid-heyanon skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/hyperliquid-heyanon',
    usageExample: '> natural language trade\n> place order conversationally\n> ask about positions',
    detailedDescription: 'Hyperliquid HeyAnon conversational AI trading integration. Place trades, check positions, and manage orders on Hyperliquid using natural language commands through the HeyAnon AI assistant. Supports intent-based order parsing, position queries, and market data retrieval via conversational interface.',
  },
  {
    id: 'hyperliquid-trading',
    name: 'hyperliquid-trading',
    author: 'Hyperliquid',
    authorHandle: '@hyperliquid_x',
    tag: 'Skill',
    category: 'trading',
    description: 'Hyperliquid trading suite. Full access to Hyperliquid on-chain order book DEX with spot, perps, vaults, and advanced order types.',
    downloads: 25600,
    stars: 1820,
    installCommand: '> install the hyperliquid-trading skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/hyperliquid-trading',
    usageExample: '> trade on Hyperliquid\n> manage perps\n> deposit to vault',
    detailedDescription: 'Comprehensive Hyperliquid trading suite providing full access to the on-chain order book decentralized exchange. Trade spot and perpetual futures with up to 50x leverage, deposit into and manage vault positions for copy-trading, and utilize advanced order types including stop-limit, trailing stop, and post-only.',
    featured: true,
  },
  {
    id: 'invective-trading-api',
    name: 'invective-trading-api',
    author: 'Invective',
    authorHandle: '@invective',
    tag: 'Skill',
    category: 'trading',
    description: 'Invective trading API wrapper. Simplified programmatic access to trading operations with built-in error handling and retry logic.',
    downloads: 4600,
    stars: 330,
    installCommand: '> install the invective-trading-api skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/invective-trading-api',
    usageExample: '> place API trade\n> handle errors\n> retry on failure',
    detailedDescription: 'Invective simplified trading API wrapper designed for developers. Provides clean programmatic interfaces for common trading operations with automatic error handling, exponential backoff retry logic, rate limit management, and detailed logging for debugging integration issues.',
  },
  {
    id: 'katbot-trading',
    name: 'katbot-trading',
    author: 'KatBot',
    authorHandle: '@katbot_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'KatBot automated trading. AI-powered signal generation, strategy execution, and portfolio management with cat-themed personality.',
    downloads: 7800,
    stars: 560,
    installCommand: '> install the katbot-trading skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/katbot-trading',
    usageExample: '> generate AI signal\n> execute strategy\n> manage portfolio',
    detailedDescription: 'KatBot AI-powered automated trading agent with a unique personality-driven interface. Generates trading signals through machine learning models, executes strategies with built-in risk management, and manages portfolios with automated rebalancing. Features entertaining status updates and cat-themed trading insights.',
  },
  {
    id: 'kryptonite-trader',
    name: 'kryptonite-trader',
    author: 'Kryptonite',
    authorHandle: '@kryptonite',
    tag: 'Skill',
    category: 'trading',
    description: 'Kryptonite trader. Super-powered automated trading with multi-strategy orchestration, advanced risk management, and performance optimization.',
    downloads: 9200,
    stars: 660,
    installCommand: '> install the kryptonite-trader skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/kryptonite-trader',
    usageExample: '> orchestrate multi-strategy\n> manage advanced risk\n> optimize performance',
    detailedDescription: 'Kryptonite super-powered automated trading system. Orchestrates multiple strategies simultaneously with capital allocation optimization, implements advanced risk management including tail risk hedging and correlation-based position limits, and continuously optimizes performance through adaptive parameter tuning.',
  },
  {
    id: 'looper-trading-agent',
    name: 'looper-trading-agent',
    author: 'Looper',
    authorHandle: '@looper_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'Looper trading agent. Circular arbitrage detection, flash loan loop strategies, and recursive position building across DeFi protocols.',
    downloads: 6800,
    stars: 490,
    installCommand: '> install the looper-trading-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/looper-trading-agent',
    usageExample: '> detect circular arb\n> execute flash loan loop\n> build recursive positions',
    detailedDescription: 'Looper specialized trading agent for circular arbitrage and recursive strategies. Detects profitable circular arbitrage paths across DEXs and lending protocols, executes flash loan loop strategies for zero-capital arbitrage, and builds recursive leveraged positions through iterative borrowing and deposit cycles.',
  },
  {
    id: 'maxi-lazy-trading',
    name: 'maxi-lazy-trading',
    author: 'Maxi',
    authorHandle: '@maxi_trading',
    tag: 'Skill',
    category: 'trading',
    description: 'Maxi lazy trading. Minimal-effort automated trading with set-and-forget strategies, weekly rebalancing, and passive income generation.',
    downloads: 11200,
    stars: 800,
    installCommand: '> install the maxi-lazy-trading skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/maxi-lazy-trading',
    usageExample: '> set strategy\n> enable weekly rebalance\n> generate passive income',
    detailedDescription: 'Maxi lazy trading system for hands-off passive trading. Deploy set-and-forget strategies with minimal configuration requirements, automatically rebalances portfolios weekly based on risk metrics, and generates passive income through yield farming, staking, and liquidity provision with zero daily intervention.',
  },
  {
    id: 'memecoin-trader',
    name: 'memecoin-trader',
    author: 'MemeTrade',
    authorHandle: '@memetrade',
    tag: 'Skill',
    category: 'trading',
    description: 'Memecoin specialist trader. Dedicated tools for meme coin discovery, entry/exit timing, and volatility management in speculative markets.',
    downloads: 16800,
    stars: 1200,
    installCommand: '> install the memecoin-trader skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/memecoin-trader',
    usageExample: '> discover new memecoin\n> time entry and exit\n> manage volatility',
    detailedDescription: 'Specialized memecoin trading system with dedicated tools for the speculative meme coin market. Discovers new tokens through social media scanning and on-chain monitoring, optimizes entry and exit timing through volume and momentum analysis, and manages extreme volatility with adaptive position sizing and trailing stop strategies.',
  },
  {
    id: 'maxx-trading-agent',
    name: 'maxx-trading-agent',
    author: 'Maxx',
    authorHandle: '@maxx_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'Maxx trading agent. Maximum performance automated trading with aggressive alpha-seeking strategies and dynamic leverage management.',
    downloads: 8400,
    stars: 600,
    installCommand: '> install the maxx-trading-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/maxx-trading-agent',
    usageExample: '> seek maximum alpha\n> manage dynamic leverage\n> execute aggressive strategy',
    detailedDescription: 'Maxx high-performance trading agent focused on maximum alpha generation. Deploys aggressive strategies including momentum chasing, breakout trading, and social sentiment arbitrage. Manages dynamic leverage that scales with conviction scores and automatically deleverages during high volatility regimes.',
  },
  {
    id: 'minia-ai',
    name: 'minia-ai',
    author: 'Minia',
    authorHandle: '@minia_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'Minia AI core. Lightweight AI trading engine, minimal resource consumption, and efficient signal generation for constrained environments.',
    downloads: 6200,
    stars: 440,
    installCommand: '> install the minia-ai skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/minia-ai',
    usageExample: '> run lightweight AI\n> generate efficient signals\n> trade in constrained env',
    detailedDescription: 'Minia lightweight AI trading engine optimized for minimal resource consumption. Generates high-quality trading signals using efficient machine learning models, operates in resource-constrained environments like edge devices and lightweight containers, and maintains performance comparable to heavyweight alternatives with 90% less compute.',
  },
  {
    id: 'minia-official',
    name: 'minia-official',
    author: 'Minia',
    authorHandle: '@minia_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'Minia official trading suite. Full-featured trading automation with official Minia strategies, backtesting, and live execution.',
    downloads: 7600,
    stars: 540,
    installCommand: '> install the minia-official skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/minia-official',
    usageExample: '> deploy official strategy\n> run backtest\n> execute live trading',
    detailedDescription: 'Minia official comprehensive trading suite. Provides pre-built official trading strategies with proven historical performance, integrated backtesting framework for strategy validation, and seamless live execution with built-in risk controls. Includes strategy marketplace for community-created Minia-compatible strategies.',
  },
  {
    id: 'monitor-agent',
    name: 'monitor-agent',
    author: 'MonitorBot',
    authorHandle: '@monitorbot',
    tag: 'Skill',
    category: 'trading',
    description: 'Trading monitor agent. 24/7 position monitoring, alert generation, anomaly detection, and automated intervention for open positions.',
    downloads: 10200,
    stars: 730,
    installCommand: '> install the monitor-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/monitor-agent',
    usageExample: '> monitor positions 24/7\n> generate alerts\n> auto-intervene',
    detailedDescription: 'Dedicated trading monitor agent providing round-the-clock position surveillance. Monitors all open positions for abnormal price movements, liquidation proximity, and exchange outages. Generates instant alerts via multiple channels, and executes automated protective interventions including stop-loss triggers and position reduction.',
  },
  {
    id: 'nuggtari',
    name: 'nuggtari',
    author: 'Nuggtari',
    authorHandle: '@nuggtari',
    tag: 'Skill',
    category: 'trading',
    description: 'Nuggtari gaming-inspired trading. Gamified trading experience, achievement system, and social trading leaderboards with unique mechanics.',
    downloads: 4800,
    stars: 350,
    installCommand: '> install the nuggtari skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/nuggtari',
    usageExample: '> start gamified trading\n> earn achievements\n> compete on leaderboard',
    detailedDescription: 'Nuggtari gamified trading platform transforming trading into an engaging experience. Earn achievements for profitable trades and streaks, compete on social leaderboards with friends, and unlock unique trading mechanics and visual customizations through gameplay progression.',
  },
  {
    id: 'nopoint-solana-trader',
    name: 'nopoint-solana-trader',
    author: 'Nopoint',
    authorHandle: '@nopoint',
    tag: 'Skill',
    category: 'trading',
    description: 'Nopoint Solana trader. Specialized Solana on-chain trading with Jupiter routing, priority fee optimization, and MEV-aware execution.',
    downloads: 7200,
    stars: 520,
    installCommand: '> install the nopoint-solana-trader skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/nopoint-solana-trader',
    usageExample: '> trade on Solana\n> optimize Jupiter route\n> execute MEV-aware',
    detailedDescription: 'Nopoint Solana specialized trading agent. Integrates Jupiter aggregator for optimal swap routing across Solana DEXs, dynamically optimizes priority fees for transaction inclusion speed, and executes trades with MEV awareness through private mempool channels and Jito bundle submission.',
  },
  {
    id: 'nopoint-trading-engine',
    name: 'nopoint-trading-engine',
    author: 'Nopoint',
    authorHandle: '@nopoint',
    tag: 'Skill',
    category: 'trading',
    description: 'Nopoint trading engine. High-performance execution engine, order matching optimization, and sub-second trade processing across venues.',
    downloads: 8400,
    stars: 600,
    installCommand: '> install the nopoint-trading-engine skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/nopoint-trading-engine',
    usageExample: '> run high-performance engine\n> optimize order matching\n> process sub-second trades',
    detailedDescription: 'Nopoint high-performance trading execution engine. Optimizes order matching for minimal latency, processes trades in sub-second timeframes through co-location and direct market access connections, and supports high-frequency strategies with tick-level data processing and microsecond execution timestamps.',
  },
  {
    id: 'open-trade-trading-suite',
    name: 'open-trade-trading-suite',
    author: 'OpenTrade',
    authorHandle: '@opentrade',
    tag: 'Skill',
    category: 'trading',
    description: 'OpenTrade trading suite. Open-source trading infrastructure, community strategy sharing, and transparent execution analytics.',
    downloads: 11200,
    stars: 800,
    installCommand: '> install the open-trade-trading-suite skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/open-trade-trading-suite',
    usageExample: '> access open-source infra\n> share community strategy\n> view transparent analytics',
    detailedDescription: 'OpenTrade open-source trading suite providing transparent and community-driven trading infrastructure. Access audited open-source trading algorithms, share strategies with the community through the strategy marketplace, and review transparent execution analytics including fill quality, slippage, and venue performance.',
  },
  {
    id: 'openswap-portfolio',
    name: 'openswap-portfolio',
    author: 'OpenSwap',
    authorHandle: '@openswap',
    tag: 'Skill',
    category: 'trading',
    description: 'OpenSwap portfolio management. Cross-chain portfolio tracking, multi-DEX position aggregation, and unified yield monitoring.',
    downloads: 6800,
    stars: 490,
    installCommand: '> install the openswap-portfolio skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/openswap-portfolio',
    usageExample: '> track cross-chain portfolio\n> aggregate multi-DEX positions\n> monitor unified yield',
    detailedDescription: 'OpenSwap cross-chain portfolio management system. Tracks positions across Ethereum, Base, Solana, and Arbitrum from a single dashboard, aggregates liquidity provision positions from multiple DEXs, and monitors unified yield from farming, staking, and lending across all supported chains.',
  },
  {
    id: 'otto-ai-trading-agent',
    name: 'otto-ai-trading-agent',
    author: 'Otto AI',
    authorHandle: '@otto_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'Otto AI trading agent. Full autonomous trading with natural language strategy creation, self-learning, and adaptive risk management.',
    downloads: 13200,
    stars: 940,
    installCommand: '> install the otto-ai-trading-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/otto-ai-trading-agent',
    usageExample: '> create strategy in natural language\n> enable self-learning\n> adapt risk management',
    detailedDescription: 'Otto AI fully autonomous trading agent. Create trading strategies through natural language descriptions that Otto translates into executable code, continuously learns from market data and trade outcomes to improve performance, and adapts risk management parameters in real-time based on portfolio state and market volatility.',
  },
  {
    id: 'otto-ai-trading',
    name: 'otto-ai-trading',
    author: 'Otto AI',
    authorHandle: '@otto_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'Otto AI trading core. AI-assisted manual trading, intelligent order suggestions, and market context analysis for informed decisions.',
    downloads: 9600,
    stars: 690,
    installCommand: '> install the otto-ai-trading skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/otto-ai-trading',
    usageExample: '> get AI suggestion\n> analyze market context\n> trade with assistance',
    detailedDescription: 'Otto AI core trading assistance module. Provides intelligent order suggestions based on market analysis and portfolio state, delivers comprehensive market context including sentiment, technical indicators, and on-chain flows, and assists manual traders with timing recommendations and risk warnings.',
  },
  {
    id: 'otto-trade-executor',
    name: 'otto-trade-executor',
    author: 'Otto AI',
    authorHandle: '@otto_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'Otto trade executor. Ultra-fast order execution, multi-venue splitting, and fill optimization with intelligent order routing.',
    downloads: 7800,
    stars: 560,
    installCommand: '> install the otto-trade-executor skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/otto-trade-executor',
    usageExample: '> execute ultra-fast order\n> split across venues\n> optimize fill quality',
    detailedDescription: 'Otto ultra-fast trade execution engine. Routes orders through fastest available channels for minimal latency, intelligently splits large orders across multiple venues for optimal fill prices, and continuously monitors fill quality to adjust routing algorithms based on real-time venue performance.',
  },
  {
    id: 'otto-trading-agent',
    name: 'otto-trading-agent',
    author: 'Otto AI',
    authorHandle: '@otto_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'Otto trading agent. Balanced automated trading with human oversight options, strategy templates, and performance dashboards.',
    downloads: 10800,
    stars: 770,
    installCommand: '> install the otto-trading-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/otto-trading-agent',
    usageExample: '> deploy balanced strategy\n> enable human oversight\n> view performance dashboard',
    detailedDescription: 'Otto balanced trading agent designed for traders who want automation with oversight. Deploys pre-built strategy templates with configurable risk levels, enables optional human approval gates for large trades, and provides comprehensive performance dashboards with PnL, drawdown, and strategy attribution analytics.',
  },
  {
    id: 'ourdex',
    name: 'ourdex',
    author: 'OurDEX',
    authorHandle: '@ourdex',
    tag: 'Skill',
    category: 'trading',
    description: 'OurDEX decentralized exchange trading. Community-owned DEX integration, governance participation, and revenue sharing through trading.',
    downloads: 5200,
    stars: 380,
    installCommand: '> install the ourdex skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/ourdex',
    usageExample: '> trade on OurDEX\n> participate in governance\n> share trading revenue',
    detailedDescription: 'OurDEX community-owned decentralized exchange trading integration. Execute trades on the community-governed OurDEX platform with competitive fees, participate in governance proposals that shape exchange parameters, and earn revenue sharing rewards proportional to trading volume contribution.',
  },
  {
    id: 'paraswap-dex-agent',
    name: 'paraswap-dex-agent',
    author: 'ParaSwap',
    authorHandle: '@paraswap',
    tag: 'Skill',
    category: 'trading',
    description: 'ParaSwap DEX agent. Aggregated DEX trading with optimal routing, gas optimization, and MEV protection through ParaSwap infrastructure.',
    downloads: 13200,
    stars: 940,
    installCommand: '> install the paraswap-dex-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/paraswap-dex-agent',
    usageExample: '> execute aggregated swap\n> find optimal route\n> protect from MEV',
    detailedDescription: 'ParaSwap DEX aggregation agent providing optimal trading across decentralized exchanges. Finds best swap routes across 50+ DEXs and liquidity sources, optimizes gas costs through transaction batching, and provides MEV protection via private transaction submission and price impact analysis.',
  },
  {
    id: 'paraswap-dex-aggregator',
    name: 'paraswap-dex-aggregator',
    author: 'ParaSwap',
    authorHandle: '@paraswap',
    tag: 'Skill',
    category: 'trading',
    description: 'ParaSwap DEX aggregator core. Deep liquidity aggregation, price comparison, and intelligent routing for best execution prices.',
    downloads: 14800,
    stars: 1060,
    installCommand: '> install the paraswap-dex-aggregator skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/paraswap-dex-aggregator',
    usageExample: '> aggregate deep liquidity\n> compare prices\n> route intelligently',
    detailedDescription: 'ParaSwap core DEX aggregation engine. Aggregates deep liquidity from 50+ DEXs and AMMs including Uniswap, Curve, Balancer, and Balancer, compares real-time prices for optimal execution, and intelligently routes orders through multi-hop paths to minimize price impact and maximize output.',
  },
  {
    id: 'pell-hyperliquid-trader',
    name: 'pell-hyperliquid-trader',
    author: 'Pell',
    authorHandle: '@pell_protocol',
    tag: 'Skill',
    category: 'trading',
    description: 'Pell Hyperliquid trader. Leveraged restaking yield, Hyperliquid perpetuals integration, and multi-protocol position management.',
    downloads: 6200,
    stars: 450,
    installCommand: '> install the pell-hyperliquid-trader skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/pell-hyperliquid-trader',
    usageExample: '> leverage restaking yield\n> trade Hyperliquid perps\n> manage multi-protocol positions',
    detailedDescription: 'Pell Protocol Hyperliquid trading integration. Combines leveraged restaking yield strategies with Hyperliquid perpetual futures trading, manages positions across multiple DeFi protocols including Pell restaking and Hyperliquid derivatives, and optimizes capital efficiency through cross-protocol collateral management.',
  },
  {
    id: 'polybot-ai',
    name: 'polybot-ai',
    author: 'Polybot',
    authorHandle: '@polybot_ai',
    tag: 'Skill',
    category: 'trading',
    description: 'Polybot AI core. Multi-chain AI trading brain, cross-chain arbitrage intelligence, and unified strategy deployment across networks.',
    downloads: 8400,
    stars: 600,
    installCommand: '> install the polybot-ai skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/trading/polybot-ai',
    usageExample: '> deploy multi-chain AI\n> find cross-chain arb\n> execute unified strategy',
    detailedDescription: 'Polybot AI core multi-chain trading intelligence. Analyzes market conditions across Ethereum, Solana, Base, and Arbitrum simultaneously, identifies cross-chain arbitrage opportunities through unified pricing models, and deploys synchronized strategies across multiple networks from a single control interface.',
  },
];